/**
 * The modifier key of this platform, for shortcut hints (QA-W4-8): « ⌘K » on
 * a Mac, « Ctrl K » elsewhere (the dialer showed ⌘K on Linux and Windows,
 * the portal already wrote Ctrl K). The handlers accept both keys anyway.
 */
export function isMacPlatform(nav: { platform?: string; userAgent?: string } | undefined = typeof navigator !== 'undefined' ? navigator : undefined): boolean {
  if (!nav) return false;
  return /Mac|iPhone|iPad|iPod/.test(nav.platform || nav.userAgent || '');
}

/** « ⌘K » or « Ctrl K ». */
export function shortcutLabel(key: string, nav?: { platform?: string; userAgent?: string }): string {
  return isMacPlatform(nav ?? (typeof navigator !== 'undefined' ? navigator : undefined)) ? `⌘${key}` : `Ctrl ${key}`;
}
